import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { UsersServices } from '@literax/components/configurations/users/services/users.services';
import { IAppState } from '@literax/store';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class ConfirmEmailGuard  {
  tokenActivate: string;
  constructor(
    private router: Router,
    private clientUsersServices: UsersServices,
    private store: Store<IAppState>
  ) {}
  canActivate(next: ActivatedRouteSnapshot) {
    return this.isRouteAllowed(next);
  }

  isRouteAllowed(route: ActivatedRouteSnapshot) {
    this.tokenActivate = route.paramMap.get('token');
    const locale = route.queryParams.locale;
    return this.redirectAndCancelNavigation(this.tokenActivate, locale);
  }

  redirectAndCancelNavigation(hasAccess, locale) {
    if (hasAccess) {
      this.router.navigate(['/register_client/' + hasAccess], {
        queryParams: { locale: locale || 'es' },
      });
      return true;
    }
    return false;
  }
}
